import { BadgeColorVariant } from '@sharedCR/coreDesignSystem/BadgeCDS/BadgeCDS.constants';

import { SnapdocsClosingLoadState } from 'constants/snapdocsClosing';

import { SnapdocsClosingSectionTestIds } from './SnapdocsClosingSection.testIds';

export const DASH = '-';

export const SNAPDOCS_OFFSET_TIMESTAMP_PATTERN =
  /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}(?::\d{2})?) ([+-]\d{2})(\d{2})$/;

export const appointmentDateTimeOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
};

export const auditTimestampOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
};

export const OFFSET_SUFFIX_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i;

export const SECTION_TITLE = 'SnapDocs Closing';

const NO_CLOSING_MESSAGE = 'No SnapDocs closing for this loan';

const UNAVAILABLE_MESSAGE = 'SnapDocs closing status is not available';

export const SKELETON_ROWS = 4;

export const EMPTY_LIST = [];

export const statusBadgeColorKeywords = [
  {
    colorVariant: BadgeColorVariant.RED,
    keywords: [
      'incomplete',
      'unsigned',
      'not ready',
      'did not sign',
      'not sign',
      'fail',
      'error',
      'cancel',
      'reject',
      'return',
      'decline',
      'expired',
    ],
  },
  {
    colorVariant: BadgeColorVariant.GREEN,
    keywords: ['complete', 'signed', 'deliver', 'ready', 'approve', 'pass', 'success', 'confirm'],
  },
  {
    colorVariant: BadgeColorVariant.ORANGE,
    keywords: ['pending', 'progress', 'review', 'warn', 'wait', 'hold'],
  },
  {
    colorVariant: BadgeColorVariant.GRAY,
    keywords: ['not applicable', 'n/a', 'none'],
  },
];

export const DEFAULT_STATUS_BADGE_COLOR = BadgeColorVariant.BLUE;

export const compactRowConfig = {
  [SnapdocsClosingLoadState.NO_CLOSING]: {
    message: NO_CLOSING_MESSAGE,
    dataTestId: SnapdocsClosingSectionTestIds.NO_CLOSING_ROW,
  },
  [SnapdocsClosingLoadState.UNAVAILABLE]: {
    message: UNAVAILABLE_MESSAGE,
    dataTestId: SnapdocsClosingSectionTestIds.UNAVAILABLE_ROW,
  },
};
